import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CatalogProduct } from '@banyan/commons/models/fragrance-catalog/catalog-product.model';
import { CatalogProductNoteFamily } from '@banyan/commons/models/fragrance-catalog/catalog-product-note-family.model';
import { DefaultCurrencyPipe } from '@banyan/commons/pipes/default-currency.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-fragrance-catalog-product-card',
  standalone: true,
  imports: [
    TranslateModule,
    DefaultCurrencyPipe
  ],
  templateUrl: './fragrance-catalog-product-card.component.html',
  styleUrls: ['./fragrance-catalog-product-card.component.scss'],
})
export class FragranceCatalogProductCardComponent {
  @Input() product: CatalogProduct | undefined;
  @Output() cardClick = new EventEmitter<void>();

  getNoteNames(noteFamilies: CatalogProductNoteFamily[] | undefined): string {
    return noteFamilies?.map(n => n.name).join(', ') ?? '';
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/catalog-default-product.png';
  }

  onCardClick() {
    this.cardClick.emit();
  }
}